import { useEffect, useState } from "react";

const TABLET_MEDIA_QUERY = "(hover: none) and (pointer: coarse) and (max-width: 1366px)";

export const useIsTablet = () => {
  const [isTablet, setIsTablet] = useState(() => globalThis.matchMedia(TABLET_MEDIA_QUERY).matches);

  useEffect(() => {
    const mediaQueryList = globalThis.matchMedia(TABLET_MEDIA_QUERY);
    const handleChange = (event) => setIsTablet(event.matches);

    mediaQueryList.addEventListener("change", handleChange);
    return () => mediaQueryList.removeEventListener("change", handleChange);
  }, []);

  return isTablet;
};
